import Rebase from "re-base";
import firebase from "firebase/app";

const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyD1sayeVQjMTh8Ly3G8TD1XiZ73Lvb76Gg",
  authDomain: "personal-travel-blog-51799.firebaseapp.com",
  databaseURL: "https://personal-travel-blog-51799-default-rtdb.firebaseio.com",
})

const base = Rebase.createClass(firebaseApp.database());

// this is named export
export { firebaseApp };

// this is default export
export default base;